import { useCallback, useContext } from 'react';
import { AuthContext } from 'src/pages/auth/context';

export type PermissionKey = string[] | string | undefined;
export type PermissionChecker = (permissionKey: PermissionKey) => boolean;

export const hasPermissionForRoles = (
  permissionKey: PermissionKey,
  userRoles: readonly string[],
): boolean => {
  if (!permissionKey || permissionKey.length === 0) return true;

  const requiredRoles = Array.isArray(permissionKey)
    ? permissionKey
    : [permissionKey];

  return userRoles.some((role) => requiredRoles.includes(role));
};

const useHasPermission = (): PermissionChecker => {
  const { userRolesName } = useContext(AuthContext);

  return useCallback(
    (permissionKey: PermissionKey) =>
      hasPermissionForRoles(permissionKey, userRolesName ?? []),
    [userRolesName],
  );
};

export default useHasPermission;
